import { animate, state, style, transition, trigger } from '@angular/animations';
import { CrudManagerLayoutBase } from './layout-base';
import { CrudTableComponent } from '../../crud-table/crud-table.component';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { CustomRouterOutlet } from '@core/frontend-shared/router/router-outlet/custom-router-outlet';
import * as i0 from "@angular/core";
function CrudManagerLayoutTableComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message");
    i0.ɵɵelement(1, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.infoMessage, i0.ɵɵsanitizeHtml);
  }
}
function CrudManagerLayoutTableComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "crud-item-table", 1);
  }
  if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
  }
}
export let CrudManagerLayoutTableComponent = /*#__PURE__*/(() => {
  class CrudManagerLayoutTableComponent extends CrudManagerLayoutBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCrudManagerLayoutTableComponent_BaseFactory;
        return function CrudManagerLayoutTableComponent_Factory(__ngFactoryType__) {
          return (ɵCrudManagerLayoutTableComponent_BaseFactory || (ɵCrudManagerLayoutTableComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CrudManagerLayoutTableComponent)))(__ngFactoryType__ || CrudManagerLayoutTableComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudManagerLayoutTableComponent,
        selectors: [["crud-manager-layout-table"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 2,
        consts: [["outlet", "outlet"], [1, "item-table"], [1, "crud-manager-router-outlet"], [3, "innerHTML"]],
        template: function CrudManagerLayoutTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CrudManagerLayoutTableComponent_Conditional_0_Template, 2, 1, "ui-message");
            i0.ɵɵconditionalCreate(1, CrudManagerLayoutTableComponent_Conditional_1_Template, 1, 1, "crud-item-table", 1);
            i0.ɵɵelement(2, "custom-router-outlet", 2, 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.editorActive() && ctx.infoMessage ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.editorActive() ? 1 : -1);
          }
        },
        dependencies: [UiMessageComponent, CrudTableComponent, CustomRouterOutlet],
        styles: ["[_nghost-%COMP%]{display:contents;padding:0}.crud-manager-router-outlet[_ngcontent-%COMP%] +   *{position:absolute;display:flex;flex-direction:column;inset:0;z-index:100;background:var(--contentColor)}@media (min-width:1280px){ui-message[_ngcontent-%COMP%]{flex:none}.item-table[_ngcontent-%COMP%]{flex:1;overflow:auto;height:initial}}\n\n/*# sourceMappingURL=layout-table.component.ts-angular-inline--32.css.map*/"],
        data: {
          animation: [trigger('fadeInOut', [state('void', style({
            opacity: 0
          })), transition('void <=> *', animate(300))])]
        }
      });
    }
  }
  return CrudManagerLayoutTableComponent;
})();